import BaseManager from "@base/manager/BaseManager";
import Facade from "@/Facade";
import GameStatesEnum from "@/states/GameStatesEnum";
import { Signals} from "@/Imports";
import Config from "@/config/Config";

export default class BalanceManager extends BaseManager {

  constructor(data) {
    super(data)
    this.init()
    this.balanceUpdateTimeout = undefined;
  }

  init() {
    Signals.stateChanged.add(this.onStateChanged, this)
    Signals.balanceUpdateBackend.add(this.sendBalanceRequest, this);
    Signals.balanceResponse.add(this.parseResponse, this)
  }

  onStateChanged(state) {
    if(state === GameStatesEnum.IDLE){
      this.idle()
    }else if(this.balanceUpdateTimeout !== undefined){
      clearTimeout(this.balanceUpdateTimeout)
    }
  }

  idle(){
    this.balanceUpdateTimeout = setTimeout(()=>{
      this.sendBalanceRequest()
      this.idle();
    }, Config.TIME_UPDATE_BALANCE)
  }

  sendBalanceRequest(){
    Signals.gameMessage.dispatch('balance')
  }

  parseResponse(response){
    Signals.balanceUpdate.dispatch(response.data.balance, this)
  }
}
